export default function AssetTransferIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 477.859 477.859"
    >
      <g>
        <path
          d="M472.863 175.662 353.396 56.195c-6.666-6.664-17.472-6.662-24.136.004a17.066 17.066 0 0 0-4.997 12.063v51.2H204.796c-9.426 0-17.067 7.641-17.067 17.067s7.641 17.067 17.067 17.067H341.33c9.426 0 17.067-7.641 17.067-17.067V109.46l78.268 78.268-78.268 78.268v-27.068c0-9.426-7.641-17.067-17.067-17.067H153.596v-51.2c-.002-9.426-7.645-17.065-17.07-17.063a17.068 17.068 0 0 0-12.063 4.997L4.997 278.062c-6.663 6.665-6.663 17.468 0 24.132l119.467 119.467c3.2 3.201 7.54 5 12.066 5.001a16.852 16.852 0 0 0 6.536-1.297 17.066 17.066 0 0 0 10.53-15.77v-51.2h119.467c9.426 0 17.067-7.641 17.067-17.067s-7.641-17.067-17.067-17.067H136.53c-9.426 0-17.067 7.641-17.067 17.067v27.068l-78.268-78.268 78.268-78.268v27.068c0 9.426 7.641 17.067 17.067 17.067h187.733v51.2c.002 9.426 7.645 17.065 17.07 17.063a17.068 17.068 0 0 0 12.063-4.997l119.467-119.467c6.662-6.665 6.662-17.468 0-24.132z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
